"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function discard(a, toDiscard) {
    return typeof toDiscard === "string" ? discardSingle(a, toDiscard) : discardMany(a, toDiscard);
}
exports.discard = discard;
function discardSingle(a, toDiscard) {
    var result = {};
    var keys = Object.keys(a);
    for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
        var key = keys_1[_i];
        if (key !== toDiscard && a.hasOwnProperty(key)) {
            result[key] = a[key];
        }
    }
    return result;
}
function discardMany(a, toDiscard) {
    var result = {};
    var keys = Object.keys(a);
    for (var _i = 0, keys_2 = keys; _i < keys_2.length; _i++) {
        var key = keys_2[_i];
        if (-1 === toDiscard.indexOf(key) && a.hasOwnProperty(key)) {
            result[key] = a[key];
        }
    }
    return result;
}
